import { useEffect, useState } from 'react';
import { Form, Steps, Button, Input, Checkbox, DatePicker, Select } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { HiUsers } from 'react-icons/hi';
import { FaUserCheck, FaUserSecret } from 'react-icons/fa';
import { RiSecurePaymentFill } from 'react-icons/ri';
import Swal from 'sweetalert2';
import { religionAndCommunityList, languageList } from '../../data.js';
import { countryAndcities } from '../../cities.js';
import './register.css';
import { Link, useNavigate } from 'react-router-dom';
import { findCommunities } from '../../utilities/utilities.js';
import { useCookies } from 'react-cookie'
import axios from 'axios';
import key from '../../key.js';
import { notification } from 'antd';
import logo from "../../images/transLogo.svg"
import { countries } from '../../states.js';


const { Step } = Steps;
const { Option } = Select;


function getCitiesByCountry(countryName) {
    let allCities = [];

    for (let i = 0; i < 152; i++) {
        if (countryAndcities[i].country_name === countryName) {
            allCities = countryAndcities[i].cities;
        }
    }
    return allCities;
}
function getStatesByCountry(countryName) {
    const countryData = countries.find(country => country.country === countryName);
    if (countryData) {
        return countryData.states;
    } else {
        return [];
    }
}
const validatePassword = (_, value) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    if (!value || regex.test(value)) {
        return Promise.resolve();
    }
    return Promise.reject(
        'Password must be at least 8 characters long, start with a capital letter, and contain at least one digit and one special character.'
    );
};
const MultistepperForm = () => {
    const [form] = Form.useForm();
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [religion, setReligion] = useState();
    const [community, setCommunity] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-registration']);


    const getCities = (value) => {
        setCitiesList(getCitiesByCountry(value));
        setStatesList(getStatesByCountry(value));
    }

    const handleNext = async () => {
        try {
            const values = await form.validateFields();
            setFormData({ ...formData, ...values });
            setCurrentStep(currentStep + 1);
        } catch (error) {
            console.log('Validation failed:', error);
        }
    };

    const handlePrev = () => {
        setCurrentStep(currentStep - 1);
    };


    useEffect(() => {
        setCommunity(findCommunities(religion))
    }, [religion])

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setFormData({ ...formData, ...values });
            const dob = formData.dob.$D + "/" + (formData.dob.$M + 1) + "/" + formData.dob.$y
            formData.dob = dob;
            let oppositeItems = [];
            for (const item of formData.lookingFor) {
                if (values.gender  === "Male" && item === 'Groom/Bride') {
                    oppositeItems.push('Bride');
                } else if (formData.gender  === 'Male' && item === 'Boy Friend/Girl Friend') {
                    oppositeItems.push('Girl Friend');
                } else if (formData.gender  === "Female" && item === 'Groom/Bride') {
                    oppositeItems.push('Groom');
                } else if (formData.gender  === 'Female' && item === 'Boy Friend/Girl Friend') {
                    oppositeItems.push('Boy Friend');
                }
            }
            formData.lookingFor = oppositeItems;
            // setFormData({ ...formData, ...values, lookingFor: oppositeItems });
            const result = await Swal.fire({
                title: 'Are you sure you want to Create?',
                // text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Create it!'
            })
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${key}/api/user/register`, formData);
                    setCookie('x-auth-registration', response.data.token, {
                        path: '/',
                        maxAge: 60 * 60 * 24 * 7 * 4 * 12,
                        sameSite: true,
                    });
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.message,
                    })
                }
                form.resetFields();
                setCurrentStep(0);
                navigate('/');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                })
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: error,
            });
        }
    }
    const steps = [
        {
            title: 'Your Name',
            content: (
                <div className='customContainer'>
                    <div className='icon'>
                        <FaUserCheck style={{ fontSize: '50px', color: 'purple' }} />
                    </div>
                    <div className='stepTitle'>Your Name</div>
                    <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[{ required: true, message: 'Please enter your first name' }]}  >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[{ required: true, message: 'Please enter your last name' }]}
                    >
                        <Input />
                    </Form.Item>
                </div>
            ),
        },
        {
            title: 'Basic Information',
            content: (
                <div className='customContainer'>
                    <div className='icon'>
                        <FaUserSecret style={{ fontSize: '50px', color: '#367588' }} />
                    </div>
                    <Form.Item
                        name="gender"
                        label="Select Gender"
                        rules={[{ required: true, message: 'Please select your gender' }]}
                    >
                        <Select placeholder="Select gender">
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="dob"
                        label="Select Date of Birth"
                        rules={[{ required: true, message: 'Please select your date of birth' }]}
                    >
                        <DatePicker style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        name="lookingFor"
                        label="You're Looking For"
                        rules={[{ required: true, message: 'Please select One' }]}
                    >
                        <Select mode='multiple' placeholder="You are Looking For">
                            <Option value="Groom/Bride">Groom/Bride</Option>
                            <Option value="Boy Friend/Girl Friend">Boy Friend/Girl Friend </Option>
                        </Select>
                    </Form.Item>
                </div>
            ),
            icon: <UserOutlined />,
        },
        {
            title: 'Personal Information',
            content: (
                <div className='customContainer'>
                    <div className='icon'>
                        <HiUsers style={{ fontSize: '50px', color: 'rgba(202, 12, 202, 0.712)' }} />
                    </div>
                    <div className='stepTitle'>Personal Information</div>
                    <Form.Item
                        name="religion"
                        label="Religion"
                        rules={[{ required: true, message: 'Please select your religion' }]}
                    >
                        <Select showSearch onChange={setReligion}>
                            {religionAndCommunityList.map((item, index) => {
                                return (
                                    <Option key={index} value={item.religion}>{item.religion}</Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="community"
                        label="Community"
                    >
                        <Select showSearch onChange={setReligion}>
                            {community.map((item, index) => {
                                return (
                                    <Option key={index} value={item}>{item}</Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="motherTongue"
                        label="Mother tongue"
                        rules={[{ required: true, message: 'Please select your Mother Tongue' }]}
                    >
                        <Select showSearch>
                            {languageList.map((item, index) => {
                                return (
                                    <Option key={index} value={item}>{item}</Option>
                                )
                            })
                            }
                        </Select>
                    </Form.Item>


                    <Form.Item
                        name="countryLiving"
                        label="Country Living In"
                        rules={[{ required: true, message: 'Please select your country' }]}
                    >
                        <Select showSearch onChange={getCities}>
                            {countryAndcities.map((item, index) => {
                                return (
                                    <Option key={index} value={item.country_name}>{item.country_name}</Option>
                                )
                            })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="stateLiving"
                        label="State Living In"
                    >
                        <Select showSearch>
                            {statesList.map((item, index) => {
                                return (
                                    <Option key={index} value={item}>{item}</Option>
                                )
                            })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="cityLiving"
                        label="City Living In"
                        rules={[{ required: true, message: 'Please select your City' }]}
                    >
                        <Select showSearch>
                            {
                                citiesList?.map((city, index) => (
                                    <Option key={index} value={city}>{city}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="residencyStatus"
                        label="Residency Status"
                        rules={[{ required: true, message: 'Please select your Residency Status' }]}
                    >
                        <Select showSearch>
                            <Option value="Citizen / Permanent Resident">Citizen / Permanent Resident</Option>
                            <Option value="Work Visa">Work Visa</Option>
                            <Option value="Student Visa">Student Visa</Option>
                            <Option value="Tourist Visa">Tourist Visa</Option>
                        </Select>
                    </Form.Item>
                </div>
            ),
        },
        {
            title: 'Account Information',
            content: (
                <div className='customContainer'>
                    <div className='icon'>
                        <FaUserSecret style={{ fontSize: '50px', color: '#7fd2eb' }} />
                    </div>
                    <div className='stepTitle'>Account Information</div>
                    <Form.Item
                        name="mobile"
                        label="Mobile Number"
                        rules={[{ required: true, message: 'Please enter your Mobile Number' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="whatsApp"
                        label="Whatsapp Number"
                        rules={[{ required: true, message: 'Please enter your Whats App Number' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, message: 'Please enter your email' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                            { required: true, message: 'Please input your password!' },
                            { validator: validatePassword },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                </div>
            ),
        },
        {
            title: 'Confirmation',
            content: (
                <div className='customContainer'>
                    <div className='icon'>
                        <RiSecurePaymentFill style={{ fontSize: '50px', color: '#7fd2eb' }} />
                    </div>
                    <div className='stepTitle text-center' style={{ fontSize: 30 }}>Account Confirmation</div>
                    <div className='text-center' style={{ fontSize: 20 }}>Read the terms and conditions before creating an account</div>

                    <Form.Item
                        name="terms"
                    >
                        <Checkbox
                            style={{ color: '#73ee0ef5', fontWeight: 'bold' }}

                        >
                            I have read the <Link to="/terms-conditions">Terms & Conditions</Link> and <Link to="/privacy-policy">Privacy Policy</Link>
                        </Checkbox>
                    </Form.Item>


                </div>
            ),

        },
    ];


    return (
        <div className='register-screen container'>
            <div className="logo">
                <img src={logo} alt="lovodi" />
            </div>
            <div className='header'>
                <div className='title'>Register</div>
                <div className='subtitle'>Create your account and start getting match</div>
            </div>
            <Form className='form' form={form}>
                <Steps current={currentStep} >
                    {steps.map((step) => (
                        <Step key={step.title} title={step.title} />
                    ))}
                </Steps>
                <div>{steps[currentStep].content}</div>
                <div className='customContainer' style={{ marginTop: '24px', display: 'flex', justifyContent: 'space-between' }}>
                    {currentStep > 0 ? (
                        <Button style={{ marginRight: '8px' }} onClick={handlePrev}>
                            Previous
                        </Button>
                    ) : (<Button style={{ marginRight: '8px', visibility: "hidden" }}>
                        Previous
                    </Button>)}
                    {currentStep < steps.length - 1 && (
                        <Button type="primary" onClick={handleNext}>
                            Continue
                        </Button>
                    )}
                    {currentStep === steps.length - 1 && (
                        <Button type="primary" onClick={handleSubmit}>
                            Create Account
                        </Button>
                    )}
                </div>
            </Form>
        </div>
    );
};

export default MultistepperForm;
